"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.round = exports.internalFormatNumber = exports.ShowColorEnum = exports.ShowSignEnum = exports.formatNumber = exports.AmountField = void 0;
const AmountField_1 = __importDefault(require("./AmountField"));
exports.AmountField = AmountField_1.default;
const utils_1 = require("./utils");
Object.defineProperty(exports, "formatNumber", { enumerable: true, get: function () { return utils_1.formatNumberAmountField; } });
Object.defineProperty(exports, "ShowSignEnum", { enumerable: true, get: function () { return utils_1.ShowSignEnum; } });
Object.defineProperty(exports, "ShowColorEnum", { enumerable: true, get: function () { return utils_1.ShowColorEnum; } });
Object.defineProperty(exports, "internalFormatNumber", { enumerable: true, get: function () { return utils_1.internalFormatNumber; } });
Object.defineProperty(exports, "round", { enumerable: true, get: function () { return utils_1.round; } });
exports.default = AmountField_1.default;
